import { useMemo } from 'react';
import { useAuth } from '@cks-internal/react-base';

export function useEnableObtBetaFeatures() {
  const { isAuthenticated, user } = useAuth();

  return useMemo(() => {
    if (!isAuthenticated || !user) return false;
    const roles: string[] = (user as any).Roles ?? [];
    return roles.some((r) => r?.toLowerCase() === 'obtbeta');
  }, [isAuthenticated, user]);
}
